/**
 * i18n Configuration
 * การตั้งค่า i18n สำหรับการรองรับหลายภาษา
 */

import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

// Import translation files
import enCommon from './locales/en/common.json'
import thCommon from './locales/th/common.json'

// Translation resources
const resources = {
  en: {
    common: enCommon,
  },
  th: {
    common: thCommon,
  },
}

void i18n
  // Detect user language
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  // Init i18next
  .init({
    resources,
    fallbackLng: 'th', // Default to Thai
    lng: 'th', // Start with Thai language

    // Namespace settings
    defaultNS: 'common',
    ns: ['common'],

    // Debug mode (disable in production)
    debug: import.meta.env.DEV,

    // Interpolation settings
    interpolation: {
      escapeValue: false, // React already escapes values
    },

    // Language detection options
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
  })

export default i18n
